import { useMemo } from "react";
import { useFeatureContext } from "contexts/FeatureContext";

interface FeatureState {
  enabled: boolean;
}

export function useFeature(featureName: string): FeatureState;
export function useFeature(featureNames: string[]): FeatureState[];
export function useFeature(
  featureNameOrNames: string | string[],
): FeatureState | FeatureState[] {
  const { isEnabled } = useFeatureContext();

  return useMemo(() => {
    if (Array.isArray(featureNameOrNames)) {
      return featureNameOrNames.map((name) => ({
        enabled: isEnabled(name),
      }));
    }

    return {
      enabled: isEnabled(featureNameOrNames),
    };
  }, [featureNameOrNames, isEnabled]);
}
